import { onCartPage } from "./bc/onCartPage";
import { onCartPopup } from "./bc/onCartPopup";

export const getHook = () => {

    if (BCSuite.platform == 'Bigcommerce') {
        return {
            onCartPage,
            onCartPopup
        }
    }
    
}